var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mt-12 mb-3 flex items-center justify-between" },
    [
      _c("div", { staticClass: "flex items-center flex-1 min-w-0" }, [
        _c(
          "h2",
          {
            staticClass:
              "xl:text-xl lg:text-lg text-base font-bold leading-7 text-gray-900 sm:text-2xl sm:leading-9 sm:truncate pr-2",
          },
          [_vm._v(_vm._s(_vm.heading))]
        ),
        _c(
          "span",
          {
            staticClass:
              "rounded-full bg-primary-500 px-2 text-white font-bold",
          },
          [_vm._v(_vm._s(_vm.total))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }